import { z } from 'zod';
import { ShareRole } from './enums';
import { uuid } from './fields';

/**
 * Master List shares — per-list Viewer/Editor invites (data-model.md §5, PRD
 * §12). Owner is expressed by `master_lists.owner_id`, NEVER a share row. REST
 * endpoints land in T29; these DTO shapes are pinned now so the role contract is
 * stable (api-contract §6).
 */

/** Full share resource (response shape). */
export const MasterListShare = z.object({
  id: uuid(),
  masterListId: uuid(),
  userId: uuid(),
  role: ShareRole,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type MasterListShare = z.infer<typeof MasterListShare>;

/** Share response enriched with the invited user's public identity. */
export const MasterListShareWithUser = MasterListShare.extend({
  email: z.string().email(),
  displayName: z.string().nullable(),
});
export type MasterListShareWithUser = z.infer<typeof MasterListShareWithUser>;

/**
 * Invite body — grantee resolved from email via Clerk lookup at invite time
 * (T29); the role is set explicitly.
 */
export const CreateMasterListShareInput = z.object({
  email: z.string().trim().email(),
  role: ShareRole,
});
export type CreateMasterListShareInput = z.infer<typeof CreateMasterListShareInput>;

/** Role-change body — the only mutable field on an existing share. */
export const UpdateMasterListShareInput = z.object({
  role: ShareRole,
});
export type UpdateMasterListShareInput = z.infer<typeof UpdateMasterListShareInput>;
